export const selectSettingsLocationHandler = (
  data,
  option,
  locations,
  isLocationSelected,
  isMachineSelected,
  selectedLocations,
) => {
  // ======= select location logic =====
  // 2. select location
  // 2.1 update the isLocationSelected
  const index = locations.indexOf(option);
  // clicking the row toggles it, and everything under it follows
  const select = !isLocationSelected[index];
  const copyIsLocationSelected = [...isLocationSelected];
  copyIsLocationSelected[index] = select;
  // isSpecificLocation logic
  const exitingSpecLocationsValue = Object.values(data).filter(
    (el) => el.isSpecificLocation,
  );

  // 2.2 update isSpecificLocationSelected
  const newIsSpecificLocationSelected = [];
  exitingSpecLocationsValue.forEach((specLocationTitle) => {
    const tempArr = [];

    newIsSpecificLocationSelected.push(tempArr);
    if (data[option].subLocations) {
      Object.keys(data[option].subLocations).forEach((el, index) => {
        if (el === Object.keys(specLocationTitle.subLocations)[index]) {
          tempArr.push(select);
        } else {
          tempArr.push(false);
        }
      });
    }
  });

  // 2.3 update isMachineSelected
  const machineNewArr = isMachineSelected[index]?.map((el) => {
    if (typeof el === 'boolean') {
      return select;
    } else {
      const machineArr = el?.map((machine) => select);
      return machineArr;
    }
  });
  const copyIsMachineSelected = [...isMachineSelected];
  copyIsMachineSelected[index] = machineNewArr;

  // for dispatch selected locations
  let newSelect;
  if (select) {
    newSelect = [...selectedLocations];
    if (!newSelect.some((el) => el === option)) {
      newSelect.push(option);
    }
  } else {
    newSelect = selectedLocations.filter((el) => el !== option);
  }

  return {
    locationList: copyIsLocationSelected,
    specificLocationList: newIsSpecificLocationSelected,
    machineList: copyIsMachineSelected,
    newSelectedLocations: newSelect,
    select,
  };
};
